/* eslint-disable @typescript-eslint/no-unsafe-assignment */
/* eslint-disable @typescript-eslint/no-unsafe-call */
/* eslint-disable @typescript-eslint/no-unsafe-member-access */
/* eslint-disable @typescript-eslint/no-unsafe-argument */
import { DsmButton, DsmGrid, DsmIcon } from '@dsm-dcs/design-system-react';
import { FC, useState } from 'react';
import { useFormContext, useWatch } from 'react-hook-form';
import { capitalize, sortedUniqBy } from 'lodash';
import { useIntl } from '../../../../../../_metronic/i18n/customUseIntl';
import { processAndStageStylesV2 } from '../../../../../../_metronic/layout';
import {
  DatabaseFoundation,
  InputAnimalOrigin,
} from '../../../../../../graphql/generated/blonk/pigs';
import { ReportingType, StageType } from '../../../../../../graphql/types';
import {
  CSSClassesList,
  ReactChangedType,
} from '../../../../helpers/helperTypes';
import { FormType, ListEntry, BeefFarms } from '../../common';
import { UserProfilePrefs } from '../../../../../modules/Helpers/UserProfilePrefs';
import { unitLong } from '../../../../utils/unit-utils';
import ReactHookDsmInput from '../../../../../modules/Helpers/ReactHookDsmInput2';
import ReactHookDsmSelect from '../../../../../modules/Helpers/ReactHookDsmSelect2';
import {
  BeefBaseline,
  BeefStage,
} from '../../../../models/Baseline/BeefBaseline';
import ReactHookDsmRadioGroup from '../../../../../modules/Helpers/ReactHookDsmRadioGroup';
import { AnimalType } from '../../../../../../graphql/generated/blonk/cattle';
import { Tooltip } from '@material-ui/core';
import { InternalSource } from '../../../../models/Baseline/CattleBaseline';
import { filterDatabaseOption } from '../../../../helpers/initialValues';

interface BeefInputPartInternalSourceProps {
  farms: BeefFarms[];
  farmId: string;
  farmName: string;
  allowedStagesForFarm: string[];
  productionProcessName: string;
  stageIndex: number;
  // eslint-disable-next-line react/require-default-props
  itemIndex: number;
  formType: FormType;
  stageType: StageType;
  fieldPrefix: string;
  // eslint-disable-next-line react/require-default-props
  removeHandler: (index: number) => void;
  // eslint-disable-next-line react/require-default-props
  triggerSelectionError?: boolean;
  updateSourceAnimalType?: (
    indexSource: number,
    stageTypeSource: StageType,
    animalTypeOptionSource: string
  ) => void;
  removeSourceAnimalType?: (indexSource: number) => void;
  shouldLockAnimalTypeSelection?: (index: number) => boolean;
  getAnimalTypeSelection?: () => string | undefined;
}

enum AnimalSytemType {
  Dairy = 'DAIRY_V2',
  Beef = 'BEEF'
}

const BeefInputPartInternalSource: FC<BeefInputPartInternalSourceProps> = ({
  farms,
  farmId,
  farmName,
  allowedStagesForFarm,
  productionProcessName,
  stageIndex,
  itemIndex,
  fieldPrefix,
  stageType,
  formType,
  removeHandler,
  triggerSelectionError = false,
  updateSourceAnimalType = () => { },
  removeSourceAnimalType = () => { },
  shouldLockAnimalTypeSelection = () => false,
  getAnimalTypeSelection = () => '',
}) => {
  const intl = useIntl();
  const classes = processAndStageStylesV2() as CSSClassesList;
  const formContext = useFormContext<BeefBaseline>();
  const userProfile = UserProfilePrefs.getInstance();
  const userUOM = userProfile.getUserUnitPrefs();
  const distanceUnit = unitLong(
    userUOM.unitTransportDistanceTerrestrial as string
  );
  const calculateInitialDatabaseValue = () => {
    let initValue: DatabaseFoundation = formContext.getValues(
      `info.databaseFoundation`
    );
    let reportingType: ReportingType =
      formContext.getValues(`info.reportingType`);
    if (!initValue) {
      const userPreference = userProfile.getUserDatabasePrefs().databaseType;
      return filterDatabaseOption(
        userPreference,
        reportingType
      ) as DatabaseFoundation;
    }
    return filterDatabaseOption(initValue, reportingType) as DatabaseFoundation;
  };
  const fieldItemPrefix = `${fieldPrefix}.internalSources.${itemIndex}`;
  let selectedFarmId = '';
  let selectedAnimalTypeId = '';
  useWatch({ name: `${fieldItemPrefix}` });
  const isGrowingStage = stageType === StageType.Growing;

  const invalidateFarmSelection = (e: ReactChangedType) => {
    const newSelection: string = e.target.value as string;
    if (newSelection !== selectedAnimalTypeId) {
      selectedAnimalTypeId = newSelection;
      formContext.setValue(`${fieldItemPrefix}.originStageId`, '');
      formContext.setValue(`${fieldItemPrefix}.averageWeight`, '');
      removeSourceAnimalType(itemIndex);

      const defFarmId = defaultFarm();
      if (defFarmId !== '') {
        const options = farmOptions();
        const defFarmnName = options.find((option) => option.value === defFarmId)?.text;
        formContext.setValue(`${fieldItemPrefix}.farmId`, defFarmId);
        formContext.setValue(`${fieldItemPrefix}.farmName`, defFarmnName);
      }
      else {
        formContext.setValue(`${fieldItemPrefix}.farmId`, '');
        formContext.setValue(`${fieldItemPrefix}.farmName`, '');
      }
    }
  };

  const invalidateStageSelection = (e: ReactChangedType) => {
    formContext.setValue(`${fieldItemPrefix}.farmName`, e.target.name);
    const newSelection: string = e.target.value as string;
    if (newSelection !== selectedFarmId) {
      formContext.setValue(`${fieldItemPrefix}.originStageId`, '');
      formContext.setValue(`${fieldItemPrefix}.averageWeight`, '');
      selectedFarmId = newSelection;
      removeSourceAnimalType(itemIndex);
    }
  };

  const addCurrentFarm = (resultFarms: ListEntry[]) => {
    const currentStage: BeefStage = formContext.getValues(
      `stages.${stageIndex}`
    );
    const currentFarm = resultFarms.find((farm) => farm.value === farmId);
    const stages = formContext
      .getValues('stages')
      .filter((stage: BeefStage) =>
        allowedStagesForFarm.includes(stage.type ?? '')
      )
      .filter((stage: BeefStage) => currentStage?.id !== stage.id);
    // If there are more then one stage on current opened baseline only then add the current farm and db
    if (stages?.length > 0 && currentFarm === undefined)
      resultFarms.push({ text: farmName, value: farmId });
  };

  const animalSystemTypeOptions = () =>
    Object.entries(AnimalSytemType).map(([text, value]) => ({
      text,
      value,
    }));

  const animalSystemTypeForm = formContext.getValues(`${fieldItemPrefix}.animalSystemType`);

  const isFarmAllowedByAnimalSystemType = (animalSystemType: string) => {
    if (isGrowingStage) {
      if (animalSystemTypeForm)
        return animalSystemType === animalSystemTypeForm;

      return false;
    }
    return true;
  }

  const farmOptions = () => {
    // Filter out the Farm that are not relevant
    const resultFarms = farms
      .filter(
        (farm) =>
          farm.databaseFoundation === calculateInitialDatabaseValue() ||
          !farm.databaseFoundation
      )
      .filter((farm) => allowedStagesForFarm.includes(farm.stageType))
      .filter((farm) => !farm.benchmark)
      .filter((farm) => isFarmAllowedByAnimalSystemType(farm.animalType))
      .map((farm) => ({ text: farm.farmName, value: farm.farmId }));
    // Add farm for currently opened stages
    const currentAnimalSystemType = formContext.getValues(`${fieldItemPrefix}.animalSystemType`);
    if (!isGrowingStage || currentAnimalSystemType === AnimalSytemType.Beef) {
      addCurrentFarm(resultFarms);
    }
    // Because a farm can have multiple processes and baselines, its entry can be duplicated
    return sortedUniqBy(resultFarms, 'value');
  };

  const generateSelectedIds = (): string[] => {
    const sources: InternalSource[] = formContext.getValues(
      `stages.${stageIndex}.stageData.input.internalSources`
    );
    return sources?.map(
      (internalSources: InternalSource) => internalSources.originStageId
    );
  };

  const formatStageType = (stageType: StageType): string => {
    if (stageType === 'DAIRY_COW' || stageType === 'CONTINUOUS_GROWING') {
      const translatedStageType = intl.formatMessage({ id: `SUSTELL.ANIMAL.SYSTEM.STAGE.SELECTION.DEFINITION.DAIRY_V2.ANIMAL_SYSTEM_STAGE_TYPE.${stageType.toUpperCase()}` });
      return capitalize(translatedStageType.toLowerCase().replace('_', ' '));
    }
    const translatedStageType = intl.formatMessage({ id: `SUSTELL.ENUMS.STAGE.TYPE.${stageType.toUpperCase()}` });
    return capitalize(translatedStageType.toLowerCase().replace('_', ' '));
  };

  const formatAnimalType = (animalType: AnimalType): string => {
    return capitalize(animalType.toLowerCase().replace('_v2', ' '));
  };

  const stageOptions = () => {
    const currentlySelectedFarm: string =
      formContext.getValues(`${fieldItemPrefix}.farmId`) || farmId;
    const currentlySelectedStage: string = formContext.getValues(
      `${fieldItemPrefix}.originStageId`
    );
    const selectedStageIds = generateSelectedIds();
    const currentStage: BeefStage = formContext.getValues(
      `stages.${stageIndex}`
    );
    const currentBaselineValues = formContext
      .getValues('stages')
      .map((stage) => ({
        databaseFoundation: calculateInitialDatabaseValue(),
        stageId: stage.id,
        stageType: stage.type,
        stageName: stage.name,
        farmId,
        productionProcessName,
        animalType: 'BEEF',
      }));

    return [...farms, ...currentBaselineValues]
      .filter(
        (farm) =>
          farm.databaseFoundation === calculateInitialDatabaseValue() ||
          !farm.databaseFoundation
      )
      .filter(
        (farm) =>
          !selectedStageIds.includes(farm.stageId) ||
          currentlySelectedStage === farm.stageId
      )
      .filter((farm) => allowedStagesForFarm.includes(String(farm.stageType)))
      .filter((farm) => farm.farmId === currentlySelectedFarm)
      .filter((farm) => farm.stageId !== currentStage?.id)
      .filter((farm) => isFarmAllowedByAnimalSystemType(farm.animalType))
      .map((farm) => ({
        text: `${formatAnimalType(farm.animalType as AnimalType)} - ${farm.stageName} (${formatStageType(farm.stageType as StageType)})`,
        value: farm.stageId,
      }));
  };

  const [selectedStageType, setSelectedStageType] = useState<StageType>(
    formContext.getValues(`${fieldItemPrefix}.stageType`)
  );

  const stageSelection = async (e: ReactChangedType) => {
    const selectedStageId: string = e.target.value as string;
    const farm: BeefFarms | undefined = farms.find(
      (f: BeefFarms) => f.stageId === selectedStageId
    );
    if (farm) {
      // Stage selected from other farm
      formContext.setValue(`${fieldItemPrefix}.farmName`, farm.farmName);
      formContext.setValue(`${fieldItemPrefix}.stageName`, farm.stageName);
      formContext.setValue(`${fieldItemPrefix}.stageType`, farm.stageType);
      formContext.setValue(`${fieldItemPrefix}.baselineRef`, farm.reference);
      if (farm.stageType === StageType.Growing) {
        formContext.setValue(`${fieldItemPrefix}.animalType`, '');
      }
      if (farm.stageType === StageType.DairyCow) {
        formContext.setValue(`${fieldItemPrefix}.animalType`, AnimalType.Calf);
      }
      updateSourceAnimalType(
        itemIndex,
        formContext.getValues(`${fieldItemPrefix}.stageType`),
        formContext.getValues(`${fieldItemPrefix}.animalType`)
      );
      setSelectedStageType(farm.stageType as StageType);
    } else {
      // Stage selected from this farm
      const currentStage: BeefStage = formContext.getValues(
        `stages.${stageIndex}`
      );
      const foundStage = formContext
        .getValues('stages')
        .filter((stage) => allowedStagesForFarm.includes(String(stage.type)))
        .filter((stage) => currentStage?.id !== stage.id)
        .find((stage) => selectedStageId === stage.id);
      if (foundStage) {
        formContext.setValue(`${fieldItemPrefix}.farmName`, farmName);
        formContext.setValue(`${fieldItemPrefix}.stageName`, foundStage.name);
        formContext.setValue(`${fieldItemPrefix}.stageType`, foundStage.type);
        formContext.setValue(`${fieldItemPrefix}.baselineRef`, '');
        if (foundStage.type === StageType.Growing) {
          formContext.setValue(`${fieldItemPrefix}.animalType`, '');
        }
        if (foundStage.type === StageType.DairyCow) {
          formContext.setValue(`${fieldItemPrefix}.animalType`, AnimalType.Calf);
        }
        updateSourceAnimalType(
          itemIndex,
          formContext.getValues(`${fieldItemPrefix}.stageType`),
          formContext.getValues(`${fieldItemPrefix}.animalType`)
        );
        setSelectedStageType(foundStage.type as StageType);
      }
    }
    await formContext.trigger(`${fieldItemPrefix}.originStageId`);
  };

  const defaultFarm = (): string => {
    const options = farmOptions();
    const farm: string =
      formContext.getValues(`${fieldItemPrefix}.farmId`) || farmId;
    const farmExists = options?.filter(
      (option: { value: string }) => option.value === farm
    )?.length;
    return farmExists ? farm : '';
  };

  const defaultStage = (): string => {
    const options = stageOptions();
    const stageId: string = formContext.getValues(
      `${fieldItemPrefix}.originStageId`
    );
    const stageExists = options?.filter(
      (option) => option.value === stageId
    )?.length;
    return stageExists ? stageId : '';
  };

  const animalTypeOptions = () =>
    Object.entries(AnimalType).map(([label, value]) => ({
      label,
      value,
    }));

  const updateRadioSelection = (value: string) => {
    updateSourceAnimalType(itemIndex, selectedStageType, value);
    formContext.trigger(`${fieldItemPrefix}.animalType`);
  };

  const getAnimalTypeValue = (): string | undefined =>
    formType !== FormType.View && shouldLockAnimalTypeSelection(itemIndex)
      ? getAnimalTypeSelection()
      : formContext.getValues(`${fieldItemPrefix}.animalType`);

  return (
    <>
      <input
        ref={formContext.register()}
        type="hidden"
        name={`${fieldItemPrefix}.origin`}
        value={InputAnimalOrigin.ProductionSystem}
      />
      <input
        ref={formContext.register()}
        type="hidden"
        name={`${fieldItemPrefix}.id`}
        value={formContext.getValues(`${fieldItemPrefix}.id`)}
      />
      <input
        ref={formContext.register()}
        type="hidden"
        name={`${fieldItemPrefix}.stageType`}
        value={formContext.getValues(`${fieldItemPrefix}.stageType`)}
      />
      <input
        ref={formContext.register()}
        type="hidden"
        name={`${fieldItemPrefix}.farmName`}
        value={formContext.getValues(`${fieldItemPrefix}.farmName`)}
      />
      <input
        ref={formContext.register()}
        type="hidden"
        name={`${fieldItemPrefix}.stageName`}
        value={formContext.getValues(`${fieldItemPrefix}.stageName`)}
      />
      <input
        ref={formContext.register()}
        type="hidden"
        name={`${fieldItemPrefix}.baselineRef`}
        value={formContext.getValues(`${fieldItemPrefix}.baselineRef`)}
      />
      <DsmGrid className={classes.additionalEntriesBlockHolder}>
        {formType !== FormType.View && (
          <DsmButton
            variant="text"
            style={{ position: 'relative', width: '100%' }}
            onClick={() => {
              removeHandler(itemIndex);
              removeSourceAnimalType(itemIndex);
            }}
          >
            <DsmIcon
              name="general/x-close"
              style={{
                position: 'absolute',
                color: 'var(--dsm-color-neutral-darker',
                right: '0',
              }}
            />
          </DsmButton>
        )}
        {isGrowingStage && (
          <div style={{ marginBottom: 'var(--dsm-spacing-px-4)' }}>
            <ReactHookDsmSelect
              style={{ width: '100%' }}
              name={`${fieldItemPrefix}.animalSystemType`}
              label={intl.formatMessage({
                id: 'SUSTELL.STAGE.BEEF.INPUT.ANIMAL_SYSTEM_TYPE',
              })}
              options={animalSystemTypeOptions()}
              changeHandler={invalidateFarmSelection}
              disabled={formType === FormType.View}
              tooltip={intl.formatMessage({
                id: 'SUSTELL.STAGE.BEEF.INPUT.ANIMAL_SYSTEM_TYPE.TOOLTIP',
              })}
              defaultValue={formContext.getValues(
                `${fieldItemPrefix}.animalSystemType`
              )}
              required
            />
          </div>
        )}
        <div style={{ marginBottom: 'var(--dsm-spacing-px-4)' }}>
          <ReactHookDsmSelect
            style={{ width: '100%' }}
            name={`${fieldItemPrefix}.farmId`}
            label={intl.formatMessage({
              id: 'SUSTELL.STAGE.BEEF.INPUT.FARM',
            })}
            disabled={formType === FormType.View}
            adornment={intl.formatMessage({
              id: 'SUSTELL.STAGE.BEEF.INPUT.FARM.ADORNMENT',
            })}
            tooltip={intl.formatMessage({
              id: 'SUSTELL.STAGE.BEEF.INPUT.FARM.TOOLTIP',
            })}
            options={farmOptions()}
            changeHandler={invalidateStageSelection}
            required
            defaultValue={defaultFarm()}
          />
        </div>
        <div style={{ marginBottom: 'var(--dsm-spacing-px-4)' }}>
          <ReactHookDsmSelect
            style={{ width: '100%' }}
            name={`${fieldItemPrefix}.originStageId`}
            label={intl.formatMessage({
              id: `SUSTELL.STAGE.BEEF.INPUT.STAGE`,
            })}
            disabled={formType === FormType.View}
            adornment={intl.formatMessage({
              id: `SUSTELL.STAGE.BEEF.INPUT.STAGE.ADORNMENT`,
            })}
            tooltip={intl.formatMessage({
              id: 'SUSTELL.STAGE.BEEF.INPUT.STAGE.TOOLTIP',
            })}
            options={stageOptions()}
            changeHandler={async (e: ReactChangedType) => {
              await stageSelection(e);
              if (triggerSelectionError)
                await formContext.trigger(
                  `stages.${stageIndex}.stageData.input.selection`
                );
            }}
            required
            defaultValue={defaultStage()}
          />
        </div>
        {isGrowingStage &&
          selectedStageType === StageType.Breeding && (
            <DsmGrid className={classes.dsmGridSmallerColumnNoRowSpacing}>
              <ReactHookDsmRadioGroup
                name={`${fieldItemPrefix}.animalType`}
                label={`${intl.formatMessage({
                  id: 'SUSTELL.STAGE.BEEF.INPUT.ANIMAL_TYPE',
                })}`}
                options={animalTypeOptions()}
                disabled={
                  formType === FormType.View ||
                  shouldLockAnimalTypeSelection(itemIndex)
                }
                defaultValue={getAnimalTypeValue()}
                required
                changeHandler={updateRadioSelection}
              />
              <Tooltip
                title={intl.formatMessage({
                  id: 'SUSTELL.STAGE.BEEF.INPUT.ANIMAL_TYPE.TOOLTIP',
                })}
                placement="left"
                style={{ transform: 'translateY(85%)' }}
              >
                <DsmIcon
                  name="general/help-circle"
                  className={classes.inlineTooltipClass}
                  title=""
                />
              </Tooltip>
            </DsmGrid>
          )}
        <ReactHookDsmInput
          name={`${fieldItemPrefix}.numberAnimals`}
          label={intl.formatMessage({
            id: `SUSTELL.STAGE.BEEF.INPUT.ANIMALS_ENTERING_STAGE`,
          })}
          adornment={intl.formatMessage({
            id: `SUSTELL.STAGE.BEEF.INPUT.ANIMALS_ENTERING_STAGE.ADORNMENT`,
          }).toLowerCase()}
          disabled={formType === FormType.View}
          tooltip={intl.formatMessage({
            id: `SUSTELL.STAGE.BEEF.INPUT.${stageType}.ANIMALS_ENTERING_STAGE.TOOLTIP`,
          })}
          required
          type="number"
          defaultValue={formContext.getValues(
            `${fieldItemPrefix}.numberAnimals`
          )}
        />
        <ReactHookDsmInput
          name={`${fieldItemPrefix}.distanceTruck`}
          type="number"
          label={intl.formatMessage({
            id: `SUSTELL.STAGE.BEEF.INPUT.DISTANCE_TRUCK`,
          })}
          adornment={distanceUnit}
          disabled={formType === FormType.View}
          tooltip={intl.formatMessage({
            id: `SUSTELL.STAGE.BEEF.INPUT.${stageType}.DISTANCE_TRUCK.TOOLTIP`,
          })}
          defaultValue={formContext.getValues(
            `${fieldItemPrefix}.distanceTruck`
          )}
        />
        <ReactHookDsmInput
          name={`${fieldItemPrefix}.shrinkingRate`}
          label={intl.formatMessage({
            id: 'SUSTELL.STAGE.BEEF.INPUT.WEIGHT_LOSS',
          })}
          disabled={formType === FormType.View}
          adornment="%"
          type="number"
          tooltip={intl.formatMessage({
            id: `SUSTELL.STAGE.BEEF.INPUT.WEIGHT_LOSS.TOOLTIP`,
          })}
          placeholder={intl.formatMessage({
            id: 'SUSTELL.STAGE.BEEF.INPUT.WEIGHT_LOSS.PLACEHOLDER',
          })}
          defaultValue={formContext.getValues(
            `${fieldItemPrefix}.shrinkingRate`
          )}
        />
      </DsmGrid>
    </>
  );
};

export default BeefInputPartInternalSource;
